"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitAccountNumberCollapseLabelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var InfoQuestionCollapseWrapperWithOptionalFields_1 = require("../../components/infoQuestion/InfoQuestionCollapseWrapperWithOptionalFields");
var journey_services_1 = require("@athena-portal/journey-services");
var DirectDebitAccountNumberCollapseLabelWidget = /** @class */ (function (_super) {
    __extends(DirectDebitAccountNumberCollapseLabelWidget, _super);
    function DirectDebitAccountNumberCollapseLabelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlurEvent = function (event) {
            _this.props.onStateChange(_this.props.question.interactionField, _this.state.accountNumber);
            _super.prototype.handleOnBlurEvent.call(_this, event);
        };
        _this.handleAccountNumberChangeEvent = function (event) {
            var accountNumber = event.target.value.replace(/[^0-9.]/g, '');
            _this.setState({ accountNumber: accountNumber });
            if (/^\d{8}$/.test(accountNumber)) {
                journey_services_1.ObjectManipulator.setField(_this.props.question.interactionField, _this.props.interaction, accountNumber);
            }
        };
        _this.state = {
            accountNumber: _this.bindFromField(props.question.interactionField),
            serviceError: false,
            classifier: ""
        };
        return _this;
    }
    DirectDebitAccountNumberCollapseLabelWidget.prototype.componentDidUpdate = function (prevProps) {
        var interactionField = this.props.question.interactionField;
        var prev = this.bindFromInteractionField(interactionField, prevProps.interaction);
        var curr = this.bindFromField(interactionField);
        if (prev !== curr && this.state.accountNumber !== curr) {
            this.setState({ accountNumber: curr !== null && curr !== void 0 ? curr : "" });
        }
    };
    DirectDebitAccountNumberCollapseLabelWidget.prototype.render = function () {
        var label = this.props.question.label ?
            (0, jsx_runtime_1.jsx)("label", { children: this.props.question.label }) : this.renderHtml(this.getSetting("labelHtml"));
        var additionalText = this.renderHtml(this.getSetting("additionalHtml"));
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionCollapseWrapperWithOptionalFields_1.InfoQuestionCollapseWrapperWithOptionalFields, { label: label, additionalText: additionalText, className: "account-number-input", children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    DirectDebitAccountNumberCollapseLabelWidget.prototype.renderInputField = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex direct-debit-account-number", children: (0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass()), id: this.props.question.name, placeholder: this.props.question.placeHolder, value: this.state.accountNumber, onChange: this.handleAccountNumberChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, maxLength: 8, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() }) }));
    };
    DirectDebitAccountNumberCollapseLabelWidget.prototype.bindFromInteractionField = function (field, interaction) {
        return journey_services_1.ObjectManipulator.fetchFieldValue(field, interaction);
    };
    DirectDebitAccountNumberCollapseLabelWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "additionalHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], DirectDebitAccountNumberCollapseLabelWidget);
    return DirectDebitAccountNumberCollapseLabelWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.DirectDebitAccountNumberCollapseLabelWidget = DirectDebitAccountNumberCollapseLabelWidget;
//# sourceMappingURL=DirectDebitAccountNumberCollapseLabelWidget.js.map